module.exports = __webpack_public_path__ + "assets/img/s3-tab-4-active-61409c6d.png";